import { AsyncPipe, JsonPipe, NgIf } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AsamcoUserService } from '@asamco/base';
import DevExpress from 'devextreme';
import { DxAccordionComponent, DxAccordionModule, DxDataGridComponent } from 'devextreme-angular';
import { DxiItemModule } from 'devextreme-angular/ui/nested';
import { BehaviorSubject, Subject, combineLatest, from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SelectedCompanyService } from '../selected-company/selected-company.service';
import { AlCompanyService } from '../services/al-company.service';
import { UsermanagementService } from '../services/usermanagement.service';
import { CompanyAccessRequestsComponent } from './company-access-requests/company-access-requests.component';
import { CompanyConfigurationComponent } from './company-configuration/company-configuration.component';
import { SubcompanyConfigurationComponent } from './subcompany-configuration/subcompany-configuration.component';
import { UserPermissionsManagementAdminComponent } from './user-permissions-management-admin/user-permissions-management-admin.component';
import { UserPermissionsManagementComponent } from './user-permissions-management/user-permissions-management.component';

@Component({
	selector: 'app-shell-usermanagement',
	templateUrl: './usermanagement.component.html',
	styleUrls: ['./usermanagement.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		AsyncPipe,
		CompanyAccessRequestsComponent,
		CompanyConfigurationComponent,
		DxAccordionModule,
		DxiItemModule,
		JsonPipe,
		NgIf,
		SubcompanyConfigurationComponent,
		UserPermissionsManagementAdminComponent,
		UserPermissionsManagementComponent,
	],
})
export class UsermanagementComponent implements AfterViewInit {
	@ViewChildren(DxAccordionComponent) accordion: QueryList<DxAccordionComponent>;

	@ViewChild('usercompanygrid') dataGrid: DxDataGridComponent;

	public readonly viewModel$ = this.selectedCompanyService.getCompanyIdObservable().pipe(
		switchMap(selectedCompanyId => combineLatest([
			this.userManagementService.isUserOwnerOfCompany(selectedCompanyId),
			this.asamcoUserService.isAdmin(),
			this.companyService.getSingleCompany(selectedCompanyId),
		])),
		map(([isCompanyOwner, isAdmin, company]) => {
			return {
				isCompanyOwner: isCompanyOwner,
				isAdmin: { isSuperAdmin: isAdmin },
				companyIsMainCompany: company.isMainCompany,
			}
		})
	);

	constructor(
		private companyService: AlCompanyService,
		private selectedCompanyService: SelectedCompanyService,
		private userManagementService: UsermanagementService,
		private asamcoUserService: AsamcoUserService,
		private activatedRoute: ActivatedRoute,
	) {}

	ngAfterViewInit() {
		combineLatest([this.accordion.changes, this.activatedRoute.params]).subscribe(r => {
			if (r[1].tab === 'access-requests') {
				// TODO: Need some sort of mapping.
				this.accordion.first.instance.option('selectedIndex', 3);
			}
		});
	}
}
